import { render, staticRenderFns } from "./ordina.vue?vue&type=template&id=a6a690b6&scoped=true&"
import script from "./ordina.vue?vue&type=script&lang=js&"
export * from "./ordina.vue?vue&type=script&lang=js&"
import style0 from "./ordina.vue?vue&type=style&index=0&id=a6a690b6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a690b6",
  null
  
)

export default component.exports